var map = {
	"./projects/digimon-deck-builder.png": 9840,
	"./projects/electronics-shop.png": 6641,
	"./projects/fast-food-template.png": 3831,
	"./projects/healthy-food-template.png": 3258,
	"./projects/ice-cream-template.png": 3583,
	"./projects/pokedex.png": 7068,
	"./projects/scraper_app.png": 8388,
	"./projects/todo-organizer.png": 4602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4278;